<mat-menu #actionMenu="matMenu">
    <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>

<div (click)="login()">
    <ng-content></ng-content>
</div>
<!--<img [src]="imageService.safeImage(googleLogo)" alt="" width="40px" style="margin:0 12px 0 0;">-->
<!--<ig-button *ngIf="!isUserLoggedWithGoogle" (trigger)="login()">G</ig-button>-->

<img #profileImg *ngIf="isUserLoggedWithGoogle" [matMenuTriggerFor]="actionMenu" [src]="profilePicture" alt="user profile picture" style="margin:10px 39%;width:46px;border-radius:23px;cursor: pointer">


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/google.login.button/google.login.button.component.html